import React, { useEffect, useState } from 'react';
import { Table, Spinner } from 'reactstrap';

function VulnerabilityTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        const headers = {
          "Content-Type": "application/json",
          ...(authUser?.token && { Authorization: `Bearer ${authUser.token}` }),
        };

        const res = await fetch(`http://localhost:5050/api/vulnerabilities`, { headers });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        const json = await res.json();
        if (json.success) {
          setData(json.vulnerabilities || []);
        } else {
          setData([]);
        }
      } catch (err) {
        console.error("Error fetching vulnerabilities:", err);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="table-responsive bg-white text-dark p-3 rounded shadow-sm">
      <h5 className="mb-3 text-dark">Detailed Findings and Analysis</h5>

      {loading ? (
        <div className="text-center p-3">
          <Spinner color="danger" />
          <p className="text-muted">Loading vulnerabilities...</p>
        </div>
      ) : (
        <Table bordered hover responsive className="align-middle mb-0">
          <thead style={{ backgroundColor: "#FFB380", border: "none", padding: "1rem 1.5rem" }}>
            <tr>
              <th>CVE ID</th>
              <th>Severity</th>
              <th>CVSS</th>
              <th>Package</th>
              <th>Version</th>
              <th>Agent</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center text-muted">
                  No vulnerability data available
                </td>
              </tr>
            ) : (
              data.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.cve}</td>
                  <td>
                    <span style={{
                      display: "inline-block",
                      padding: "2px 10px",
                      borderRadius: 20,
                      fontSize: 11,
                      fontWeight: 700,
                      color: item.severity === 'Critical' ? '#dc2626' : item.severity === 'High' ? '#ea580c' : item.severity === 'Medium' ? '#d97706' : '#16a34a',
                      backgroundColor: item.severity === 'Critical' ? '#fef2f2' : item.severity === 'High' ? '#fff7ed' : item.severity === 'Medium' ? '#fffbeb' : '#f0fdf4',
                      border: item.severity === 'Critical' ? '1px solid #fecaca' : item.severity === 'High' ? '1px solid #fed7aa' : item.severity === 'Medium' ? '1px solid #fde68a' : '1px solid #bbf7d0',
                    }}>
                      {item.severity}
                    </span>
                  </td>
                  <td>{item.cvss_score}</td>
                  <td>{item.package_name}</td>
                  <td>{item.package_version}</td>
                  <td>{item.agent_name}</td>
                  <td>{item.status}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </div>
  );
}

export default VulnerabilityTable;
